module.exports = __webpack_public_path__ + "img/Logosisvocbranca.a917a876.svg";